import React from 'react'
import './style.sass'

const Loading = () => <div className="loading"><div className="lds-ripple"><div /><div /></div></div>

export default Loading